<template>
  <div>
    {{scale.fact}}
  </div>
</template>

<script>

import {dynamicScaleComponent} from "@/mixins/dynamicScaleComponent";
import ClickToEdit from "@/components/ClickToEdit";

export default {
  name: "progressive-card-fact-view",
  mixins: [dynamicScaleComponent],
  components: {ClickToEdit},

  props: {
    disabled:{type: Boolean, default: false}
  },

  data() {
    return {
      scale:{
        fact: null,
      },
    }
  },
  mounted() {

  },
  computed: {

  },
  methods: {

  }
}
</script>

<style>

</style>